<section class="overflow-x-hidden border-b-2 border-primary-500">

  @if(view.site?.id != 79) {
    @if(view.imageLayer1) {
    <app-banner_section-type01 [options]="{ title: '', imageHref: view.imageLayer1 }"></app-banner_section-type01>
    } @else {
    <div class="w-full h-[280px] bg-primary-100" aria-hidden="true"></div>
    }
  }

  @if(view.page && view.site?.id === 79) {
  <!-- Header image with smooth flowing bottom -->
  <div class="relative h-[600px] overflow-hidden bg-primary-100">
    @if(view.imageLayer1) {
    <!-- Layer 1 -->
    <img [src]="view.imageLayer1" alt="Slideshow Image"
      class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
      [class.opacity-0]="view.activeLayer !== 1 || !view.bannerLoaded"
      [class.opacity-100]="view.activeLayer === 1 && view.bannerLoaded"
      (load)="onBannerLoad()"
      (error)="onBannerError()" />

    <!-- Layer 2 -->
    <img [src]="view.imageLayer2" alt="Slideshow Image"
      class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
      [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />
    }
    @if(view.bannerError) {
    <div class="absolute inset-0 bg-primary-100" aria-hidden="true"></div>
    }
    <!-- Flowing wave SVG cut -->
    <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
      <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
    </svg>
  </div>
  }
  <!-- Content section below -->
  <div class="flex flex-col justify-center bg-white py-7 px-6 sm:px-12 lg:px-20">

    @if(view.site?.id !== 79){
    <div class="flex flex-col w-full pt-3 px-6 md:px-12 items-center text-center">
      <h2 class="text-3xl md:text-4xl text-primary font-extrabold mb-6 tracking-tight leading-snug">
        {{view.page?.content.name}}
      </h2>
      <p class="text-gray-600 leading-relaxed max-w-5xl" [innerHTML]="view.page?.content.rawContent"></p>
    </div>
    }
    
    @if(view.site?.id === 79) {
    <div class="flex flex-col justify-center w-full">
      <div class="flex justify-center">
        <img src="/assets/images/sections/ST ABOUT US.png" class="w-100" alt="about us header image">
      </div>
      <div class="flex w-full justify-center">
      <p class="text-lg text-center md:text-xl leading-relaxed max-w-5xl" [innerHTML]="view.page?.content.rawContent">
      </div>
    </div>
    }

    @if(view.site?.id !== 104 && view.site?.id !== 99 && view.site?.id !== 89 && view.site?.id !== 120 && view.site?.id !== 58 && view.site?.id !== 96 && view.site?.id !== 163) {
    <div class="flex justify-center mt-8">
      <button [routerLink]="'/team'"
        class="px-6 py-3 bg-accent-500 text-white rounded-lg hover:bg-primary-100 hover:text-primary-500 transition-all duration-300">
        Meet our Team
      </button>
    </div>
    }
  </div>

</section>